export enum ImportFileTypeEnum {
  MULTIPRESS = 'multipress',
  COMMERCE = 'commerce',
  EXTERNAL = 'external',
}
